import { render, staticRenderFns } from "./ChangePasswordModalComponent.vue?vue&type=template&id=0530becd&scoped=true&"
import script from "./ChangePasswordModalComponent.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordModalComponent.vue?vue&type=style&index=0&id=0530becd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0530becd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0530becd')) {
      api.createRecord('0530becd', component.options)
    } else {
      api.reload('0530becd', component.options)
    }
    module.hot.accept("./ChangePasswordModalComponent.vue?vue&type=template&id=0530becd&scoped=true&", function () {
      api.rerender('0530becd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/ChangePasswordModalComponent.vue"
export default component.exports